/**
 * STIL temasi — dizayn TILI (glass/classic/soft), rangdan ALOHIDA.
 *
 * `data-style` atributi orqali qo'llanadi (global.css'dagi `[data-style]`
 * override'lari kartalar/blur/fonni almashtiradi). Default ("glass") =
 * hozirgi shisha (glassmorphism) — data-style QO'YILMAYDI.
 * Yorug'/qorong'u rejimdan mustaqil.
 */

export type Style = 'glass' | 'classic' | 'soft' | 'neo' | 'flat' | 'material';

const STORAGE_KEY = 'avtofix-style';

export interface StyleOption {
  id: Style;
  name: string;
  desc: string;
}

export const STYLES: StyleOption[] = [
  { id: 'glass', name: 'Shisha', desc: 'Shaffof + blur (joriy)' },
  { id: 'classic', name: 'Klassik', desc: 'Keskin, tiniq ERP' },
  { id: 'soft', name: 'Yumshoq', desc: 'Yumaloq, mayin soya' },
  { id: 'neo', name: 'Neo', desc: 'Neumorf, monoxrom' },
  { id: 'flat', name: 'Tekis', desc: 'Toza, soyasiz, geometrik' },
  { id: 'material', name: 'Material', desc: 'Kuchli ko‘tarilgan soya' },
];

// Default = 'classic' (professional ERP uslubi). Modern shisha (glass) — ixtiyoriy.
const DEFAULT_STYLE: Style = 'classic';

export function getStyle(): Style {
  if (typeof window === 'undefined') return DEFAULT_STYLE;
  const s = localStorage.getItem(STORAGE_KEY);
  return STYLES.some((o) => o.id === s) ? (s as Style) : DEFAULT_STYLE;
}

export function applyStyle(style: Style): void {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  if (style === 'glass') {
    root.removeAttribute('data-style');
  } else {
    root.setAttribute('data-style', style);
  }
  try {
    localStorage.setItem(STORAGE_KEY, style);
  } catch {
    /* localStorage mavjud emas — e'tiborsiz */
  }
}
